(() => {
  const configScript = document.getElementById('recharge-best-value-label-config');
  let config = {};

  if (configScript?.textContent) {
    try {
      config = JSON.parse(configScript.textContent);
    } catch {
      config = {};
    }
  }

  const subscriptionBestValueText = config.text || '';
  const subscriptionBestValueUseBrush = Boolean(config.useBrush);
  const subscriptionMessage =
    config.subscriptionMessage || 'You can skip, pause or change the frequency at any time.';
  const WATCH_TIMEOUT_MS = 5000;

  function wrapAndAddChild(targetElement) {
    if (targetElement.parentElement?.classList.contains('custom-message-wrapper')) {
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('custom-message-wrapper');
    targetElement.parentNode.insertBefore(wrapper, targetElement);
    wrapper.appendChild(targetElement);

    const child = document.createElement('div');
    child.classList.add('custom-message');
    child.innerText = subscriptionMessage;
    wrapper.appendChild(child);
  }

  function getEnhancedWidgetPricesTarget() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget?.shadowRoot || widget.shadowRoot.childElementCount === 0) {
      return null;
    }

    const subscriptionSection = widget.shadowRoot.querySelector('[part*="rc-purchase-option__subscription"]');
    if (!subscriptionSection) {
      return null;
    }

    return subscriptionSection.querySelector('[part*="rc-purchase-option__prices"]');
  }

  function applyShadowDomBestValueStyles(label) {
    Object.assign(label.style, {
      marginLeft: 'auto',
      marginRight: '12px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'var(--best-value-label-bg, #f18800)',
      color: 'var(--best-value-label-color, #ffffff)',
      textAlign: 'center',
      fontSize: 'var(--best-value-label-font-size, 14px)',
      lineHeight: 'var(--best-value-label-line-height, 1.15)',
      letterSpacing: '0',
      borderRadius: '50px',
      fontWeight: '700',
      zIndex: '1',
      padding: '4px 10px',
      order: '-1',
      whiteSpace: 'nowrap'
    });

    if (subscriptionBestValueUseBrush) {
      label.style.fontFamily = 'var(--font-rca-subheading-family)';
      label.style.fontWeight = '400';
      label.style.letterSpacing = '0.54px';
    }
  }

  function addBestValueLabelToTarget(target) {
    if (!target || !subscriptionBestValueText || target.hasAttribute('data-best-value-label-added')) {
      return false;
    }

    const label = document.createElement('span');
    label.classList.add('rc-radio__label_best_value');
    label.setAttribute('data-best-value-label', 'true');
    if (subscriptionBestValueUseBrush) {
      label.classList.add('rc-radio__label_best_value--brush');
    }
    label.textContent = subscriptionBestValueText;

    if (target.getRootNode() instanceof ShadowRoot) {
      Object.assign(target.style, {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px'
      });
      applyShadowDomBestValueStyles(label);
    }

    target.appendChild(label);
    target.setAttribute('data-best-value-label-added', 'true');
    return true;
  }

  function setOneTimeLabel(text) {
    const labelArray = text.split(' ');

    const nameLabel = document.createElement('span');
    nameLabel.classList.add('rc-radio-onetime-text__label');
    nameLabel.textContent = 'One-time purchase';

    const priceLabel = document.createElement('span');
    priceLabel.classList.add('rc-radio-onetime-text__label');
    priceLabel.classList.add('rc-radio__price');
    priceLabel.textContent = labelArray[labelArray.length - 1];

    return { label: nameLabel, price: priceLabel };
  }

  function checkForTargetElement() {
    const legacySubscriptionTarget = document.querySelector('.subscription-radio .rc-radio__label');
    const enhancedPricesTarget = getEnhancedWidgetPricesTarget();
    const oneTimeElement = document.querySelector('.onetime-radio .rc-radio__label');

    if (oneTimeElement && !oneTimeElement.querySelector('.rc-radio-onetime-text__label')) {
      const content = setOneTimeLabel(oneTimeElement.textContent);
      oneTimeElement.textContent = '';
      oneTimeElement.appendChild(content.label);
      oneTimeElement.appendChild(content.price);
    }

    if (legacySubscriptionTarget) {
      wrapAndAddChild(legacySubscriptionTarget);
      return addBestValueLabelToTarget(legacySubscriptionTarget);
    }

    if (enhancedPricesTarget) {
      return addBestValueLabelToTarget(enhancedPricesTarget);
    }

    return false;
  }

  let bodyObserver = null;
  let shadowObserver = null;
  let watchTimeoutId = null;
  let watchedWidget = null;

  function teardownWatchers() {
    bodyObserver?.disconnect();
    shadowObserver?.disconnect();
    clearTimeout(watchTimeoutId);
    bodyObserver = null;
    shadowObserver = null;
    watchedWidget = null;
  }

  function tryApplyBestValueLabel() {
    if (checkForTargetElement()) {
      teardownWatchers();
      return true;
    }
    return false;
  }

  function watchEnhancedWidgetShadow(widget) {
    if (!widget?.shadowRoot || watchedWidget === widget) return;

    watchedWidget = widget;
    shadowObserver?.disconnect();

    shadowObserver = new MutationObserver(() => {
      tryApplyBestValueLabel();
    });

    shadowObserver.observe(widget.shadowRoot, { childList: true, subtree: true });
    tryApplyBestValueLabel();
  }

  function ensureWatchingEnhancedWidget() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;

    watchEnhancedWidgetShadow(widget);
  }

  function onBodyMutation() {
    ensureWatchingEnhancedWidget();
    tryApplyBestValueLabel();
  }

  function init() {
    if (tryApplyBestValueLabel()) return;

    bodyObserver = new MutationObserver(onBodyMutation);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    ensureWatchingEnhancedWidget();

    watchTimeoutId = setTimeout(teardownWatchers, WATCH_TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
